// All translations for TL Event Group - NL (default) and EN

export const translations = {
  nl: {
    nav: {
      home: 'Home',
      structures: 'Structuren',
      portfolio: 'Portfolio',
      about: 'Over ons',
      contact: 'Contact',
    },
    cta: {
      quote: 'Offerte aanvragen',
      discover: 'Ontdekken',
      viewAll: 'Alles bekijken',
      viewAllStructures: 'Alle structuren bekijken',
      requestStructure: 'Deze structuur aanvragen',
      keepMeInformed: 'Houd mij op de hoogte',
      learnMore: 'Meer informatie',
      startProject: 'Uw project starten',
      discussProject: 'Bespreek uw project',
      submitting: 'Verzenden…',
      submit: 'Aanvraag indienen',
      newRequest: 'Nieuwe aanvraag',
    },
    common: {
      comingSoon: 'Coming Soon',
      comingSoonLong: 'Binnenkort beschikbaar',
      collection: 'Onze Collectie',
      inspiration: 'Inspiratie',
      ourWork: 'Ons Werk',
      ourStory: 'Ons Verhaal',
      whatDefinesUs: 'Wat ons definieert',
      portfolio: 'Portfolio',
      getInTouch: 'Neem contact op',
    },
    specs: {
      capacity: 'Capaciteit',
      dimensions: 'Afmetingen',
      material: 'Materiaal',
      setup: 'Opbouwtijd',
    },
    home: {
      heroSubtitle: 'Premium Evenementstructuren & Infrastructuur',
      structuresTitle: 'Architecturale Structuren',
      inspirationTitle: 'Sfeer & mogelijkheden',
      inspirationSub: 'Een kleine selectie van sferen en opstellingen ter inspiratie. Onze eigen referentieprojecten zijn in opbouw — neem contact op om de mogelijkheden te bespreken.',
      aboutTitle: 'Wij verhuren geen tenten. Wij creëren sfeer.',
      aboutP1: 'TL Event Group levert premium evenementstructuren en infrastructuur voor evenementen in België en Nederland. Wij verzorgen alles — van levering en professionele installatie tot volledige afbraak — met onberispelijke kwaliteit in elke fase.',
      aboutP2: 'Wij leveren niet zomaar tenten — wij creëren complete omgevingen. Elk project begint met een persoonlijk terreinbezoek, gedetailleerde structuurplanning en eindigt met een professioneel geïnstalleerde ruimte die alle verwachtingen overtreft.',
    },
    features: {
      quality: { title: 'Kwaliteitsgarantie', desc: 'Elke structuur wordt professioneel geïnstalleerd en onderhouden voor een vlekkeloze uitvoering.' },
      service: { title: 'Volledige Service', desc: 'Van levering en opbouw tot afbraak — wij regelen de volledige infrastructuur zodat u zich kunt focussen op de beleving.' },
      premium: { title: 'Premium Materialen', desc: 'Alleen de hoogwaardige stoffen, frames en bevestigingen. Onze structuren zijn gebouwd om indruk te maken.' },
    },
    stats: {
      structures: { label: 'Tentstructuren', sub: 'unieke configuraties' },
      flooring: { label: 'Evenementvloeren', sub: 'beschikbare voorraad' },
      countries: { label: 'Landen', sub: 'België & Nederland' },
      service: { value: 'Last-minute', label: 'Service', sub: 'snelle interventie & opbouw' },
    },
    tents: {
      pagode: {
        name: 'Pergola Tenten',
        tagline: 'Geometrische Precisie',
        description: 'Elegante gepiekste structuren ideaal voor intieme bijeenkomsten en modulaire configuraties. Kunnen worden gecombineerd in rijen of roosters voor grotere evenementen.',
        setup: '2-4u',
      },
      stretch: {
        name: 'Stretch Tenten',
        tagline: 'Organische Elegantie',
        description: 'Vloeiende, sculpturale vormen die zich aanpassen aan elk landschap. Perfect voor het creëren van dramatische, vrije overdekte ruimtes.',
        setup: '4-8u',
      },
      glass: {
        name: 'Kader Tenten',
        tagline: 'Transparante Luxe',
        description: 'Elegante kaderstructuren beschikbaar met zowel transparante als witte doeken, zodat u de sfeer volledig kan afstemmen op uw evenement. Klimaatgecontroleerd voor gebruik het hele jaar rond, met ongeëvenaarde elegantie.',
        setup: '1-2 dagen',
      },
      silhouette: {
        name: 'Sailcloth Tenten',
        tagline: 'Dramatische Vorm',
        description: 'Gepiekste, strak gespannen doekstructuren met dramatische daklijn. Het architectonische middelpunt voor elke grootschalige viering.',
        setup: '1-2 dagen',
      },
      dimensions: { custom: 'Op maat' },
    },
    extras: {
      title: 'Extra Materialen',
      flooring: { title: 'Evenementvloeren', desc: 'Hardhouten, tapijt- en platformvloersystemen voor elk terrein.' },
      furniture: { title: 'Meubilair & Decoratie', desc: 'Tafels, stoelen, loungesets, bars en decoratieve elementen voor complete evenementstijling.' },
      climate: { title: 'Klimaat & Verlichting', desc: 'Verwarming, koeling en professionele verlichtingsinstallaties voor de perfecte sfeer.' },
    },
    portfolioPage: {
      eyebrow: 'Inspiratie',
      title: 'Sfeer & mogelijkheden',
      note: 'Onze referentieprojecten zijn momenteel in opbouw. Hieronder vindt u een selectie van sferen en opstellingen ter inspiratie. Voor concrete mogelijkheden voor uw evenement, neem gerust contact met ons op — we komen graag persoonlijk langs.',
    },
    about: {
      heading: 'Over TL Event Group',
      p1: 'TL Event Group ontstond vanuit een eenvoudig geloof: de ruimte waar mensen samenkomen moet net zo bijzonder zijn als de gelegenheid zelf.',
      p2: 'Wij leveren niet zomaar tenten — wij creëren complete omgevingen. Elk project begint met een persoonlijk terreinbezoek, gedetailleerde structuurplanning en eindigt met een professioneel geïnstalleerde ruimte die alle verwachtingen overtreft.',
      valuesTitle: 'Onze Waarden',
      values: {
        precision: { title: 'Precisie', desc: 'Elke structuur wordt gemeten, getest en geïnstalleerd met engineeringnauwkeurigheid.' },
        craftsmanship: { title: 'Vakmanschap', desc: 'We selecteren materialen op prestatie, schoonheid en duurzaamheid — geen compromissen.' },
        service: { title: 'Volledige Service', desc: 'Van eerste terreinbezoek tot definitieve afbraak, één team regelt alles naadloos.' },
        reliability: { title: 'Betrouwbaarheid', desc: 'Weersbestendig getest, draagvermogen gecertificeerd, en gesteund door een decennium ervaring.' },
      },
    },
    contact: {
      heading: 'Contact',
      intro: 'Klaar om uw evenement te bespreken? Neem contact met ons op en we plannen een persoonlijk terreinbezoek om de mogelijkheden samen te verkennen.',
      labels: {
        email: 'E-mail',
        phone: 'Telefoon',
        area: 'Werkgebied',
        areaValue: 'België & Nederland',
        fullName: 'Volledige naam *',
        emailReq: 'E-mail *',
        phoneOpt: 'Telefoon',
        eventType: 'Type evenement',
        selectType: 'Selecteer type',
        eventDate: 'Evenementdatum',
        guests: 'Aantal gasten',
        interests: 'Interessante structuren',
        message: 'Bericht',
      },
      eventTypes: ['Bruiloft', 'Zakelijk', 'Festival', 'Privéfeest', 'Anders'],
      interests: ['Pergola Tenten', 'Stretch Tenten', 'Kader Tenten', 'Sailcloth Tenten', 'Evenementvloeren', 'Meubilair & Decoratie', 'Klimaat & Verlichting'],
      success: {
        title: 'Bedankt voor uw aanvraag',
        text: 'Wij hebben uw bericht goed ontvangen. Een lid van ons team neemt binnen 24 uur persoonlijk contact met u op om uw evenement te bespreken.',
      },
      toasts: {
        missing: 'Vul uw naam en e-mail in.',
        sent: 'Aanvraag verzonden — wij nemen spoedig contact op.',
        failed: 'Verzenden mislukt',
      },
    },
    footer: {
      desc: 'Premium evenementstructuren en infrastructuur voor onvergetelijke evenementen in België en Nederland. Wij creëren sfeer met architecturale precisie.',
      navigation: 'Navigatie',
      contact: 'Contact',
      areaValue: 'België & Nederland',
      copy: 'Alle rechten voorbehouden.',
      tag: 'Premium Evenementstructuren & Infrastructuur',
    },
  },

  en: {
    nav: {
      home: 'Home',
      structures: 'Structures',
      portfolio: 'Portfolio',
      about: 'About',
      contact: 'Contact',
    },
    cta: {
      quote: 'Request quote',
      discover: 'Discover',
      viewAll: 'View all',
      viewAllStructures: 'View all structures',
      requestStructure: 'Request this structure',
      keepMeInformed: 'Keep me informed',
      learnMore: 'Learn more',
      startProject: 'Start your project',
      discussProject: 'Discuss your project',
      submitting: 'Sending…',
      submit: 'Submit request',
      newRequest: 'New request',
    },
    common: {
      comingSoon: 'Coming Soon',
      comingSoonLong: 'Coming soon',
      collection: 'Our Collection',
      inspiration: 'Inspiration',
      ourWork: 'Our Work',
      ourStory: 'Our Story',
      whatDefinesUs: 'What defines us',
      portfolio: 'Portfolio',
      getInTouch: 'Get in touch',
    },
    specs: {
      capacity: 'Capacity',
      dimensions: 'Dimensions',
      material: 'Material',
      setup: 'Setup time',
    },
    home: {
      heroSubtitle: 'Premium Event Structures & Infrastructure',
      structuresTitle: 'Architectural Structures',
      inspirationTitle: 'Atmosphere & possibilities',
      inspirationSub: 'A small selection of moods and arrangements for inspiration. Our own reference projects are in development — get in touch to discuss the possibilities.',
      aboutTitle: "We don't rent tents. We create atmosphere.",
      aboutP1: 'TL Event Group provides premium event structures and infrastructure for events across Belgium and the Netherlands. We handle everything — from delivery and professional installation to complete dismantling — with impeccable quality at every stage.',
      aboutP2: "We don't just supply tents — we create complete environments. Every project begins with a personal site visit, detailed structural planning, and ends with a professionally installed space that exceeds every expectation.",
    },
    features: {
      quality: { title: 'Quality Guarantee', desc: 'Every structure is professionally installed and maintained for flawless execution.' },
      service: { title: 'Full Service', desc: 'From delivery and setup to dismantling — we manage the complete infrastructure so you can focus on the experience.' },
      premium: { title: 'Premium Materials', desc: 'Only high-grade fabrics, frames and fittings. Our structures are built to impress.' },
    },
    stats: {
      structures: { label: 'Tent structures', sub: 'unique configurations' },
      flooring: { label: 'Event flooring', sub: 'available stock' },
      countries: { label: 'Countries', sub: 'Belgium & Netherlands' },
      service: { value: 'Last-minute', label: 'Service', sub: 'fast intervention & setup' },
    },
    tents: {
      pagode: {
        name: 'Pergola Tents',
        tagline: 'Geometric Precision',
        description: 'Elegant peaked structures ideal for intimate gatherings and modular configurations. Can be combined in rows or grids for larger events.',
        setup: '2-4h',
      },
      stretch: {
        name: 'Stretch Tents',
        tagline: 'Organic Elegance',
        description: 'Flowing, sculptural shapes that adapt to any landscape. Perfect for creating dramatic, free-form covered spaces.',
        setup: '4-8h',
      },
      glass: {
        name: 'Frame Tents',
        tagline: 'Transparent Luxury',
        description: 'Elegant frame structures available with both transparent and white canvas options, letting you tailor the atmosphere entirely to your event. Climate-controlled for year-round use, with unmatched elegance.',
        setup: '1-2 days',
      },
      silhouette: {
        name: 'Sailcloth Tents',
        tagline: 'Dramatic Form',
        description: 'Peaked, taut canvas structures with a dramatic rooflines. The architectural centrepiece for any large-scale celebration.',
        setup: '1-2 days',
      },
      dimensions: { custom: 'Custom' },
    },
    extras: {
      title: 'Additional Equipment',
      flooring: { title: 'Event Flooring', desc: 'Hardwood, carpet and platform flooring systems for any terrain.' },
      furniture: { title: 'Furniture & Decor', desc: 'Tables, chairs, lounge sets, bars and decorative elements for complete event styling.' },
      climate: { title: 'Climate & Lighting', desc: 'Heating, cooling and professional lighting installations for the perfect atmosphere.' },
    },
    portfolioPage: {
      eyebrow: 'Inspiration',
      title: 'Atmosphere & possibilities',
      note: 'Our reference projects are currently in development. Below you will find a selection of moods and arrangements for inspiration. For concrete possibilities for your event, please get in touch — we are happy to visit you in person.',
    },
    about: {
      heading: 'About TL Event Group',
      p1: 'TL Event Group was born from a simple belief: the space where people gather should be just as remarkable as the occasion itself.',
      p2: "We don't just supply tents — we create complete environments. Every project begins with a personal site visit, detailed structural planning, and ends with a professionally installed space that exceeds every expectation.",
      valuesTitle: 'Our Values',
      values: {
        precision: { title: 'Precision', desc: 'Every structure is measured, tested and installed with engineering accuracy.' },
        craftsmanship: { title: 'Craftsmanship', desc: 'We select materials for performance, beauty and durability — no compromises.' },
        service: { title: 'Full Service', desc: 'From the first site visit to final dismantling, one team handles everything seamlessly.' },
        reliability: { title: 'Reliability', desc: 'Weather-tested, load-certified and backed by a decade of experience.' },
      },
    },
    contact: {
      heading: 'Contact',
      intro: 'Ready to discuss your event? Get in touch and we will arrange a personal site visit to explore the possibilities together.',
      labels: {
        email: 'Email',
        phone: 'Phone',
        area: 'Service area',
        areaValue: 'Belgium & Netherlands',
        fullName: 'Full name *',
        emailReq: 'Email *',
        phoneOpt: 'Phone',
        eventType: 'Event type',
        selectType: 'Select type',
        eventDate: 'Event date',
        guests: 'Number of guests',
        interests: 'Structures of interest',
        message: 'Message',
      },
      eventTypes: ['Wedding', 'Corporate', 'Festival', 'Private party', 'Other'],
      interests: ['Pergola Tents', 'Stretch Tents', 'Frame Tents', 'Sailcloth Tents', 'Event flooring', 'Furniture & Decor', 'Climate & Lighting'],
      success: {
        title: 'Thank you for your request',
        text: 'We have received your message. A member of our team will personally contact you within 24 hours to discuss your event.',
      },
      toasts: {
        missing: 'Please fill in your name and email.',
        sent: 'Request sent — we will be in touch soon.',
        failed: 'Sending failed',
      },
    },
    footer: {
      desc: 'Premium event structures and infrastructure for unforgettable events in Belgium and the Netherlands. We create atmosphere with architectural precision.',
      navigation: 'Navigation',
      contact: 'Contact',
      areaValue: 'Belgium & Netherlands',
      copy: 'All rights reserved.',
      tag: 'Premium Event Structures & Infrastructure',
    },
  },
};
